export const recipesData = [
  {
    id: 1,
    slug: 'peanut-butter-protein-smoothie',
    title: 'Peanut Butter Protein Smoothie',
    excerpt: 'A thick, creamy, high-protein smoothie packed with peanut butter and whey protein. Perfect post-workout fuel with 35g protein.',
    category: 'Smoothies',
    prepTime: '5 min',
    servings: 1,
    calories: 420,
    protein: '35g',
    carbs: '32g',
    fat: '18g',
    difficulty: 'Easy',
    image: 'https://images.unsplash.com/photo-1553787499-6f9133860278?w=800&q=80',
    tags: ['protein shake', 'peanut butter', 'post workout', 'smoothie', 'high protein'],
    ingredients: [
      '1 scoop whey protein (chocolate or vanilla)',
      '2 tablespoons natural peanut butter',
      '1 medium banana (frozen for thickness)',
      '1 cup milk (dairy or almond)',
      '1/2 cup Greek yogurt',
      '1 tablespoon honey (optional)',
      '4-5 ice cubes',
    ],
    instructions: [
      'Add milk and Greek yogurt to your blender first for a smooth base.',
      'Drop in the frozen banana broken into chunks and the peanut butter.',
      'Add your scoop of whey protein powder.',
      'Add honey if you prefer extra sweetness.',
      'Toss in the ice cubes and blend on high for 45-60 seconds until completely smooth and creamy.',
      'Pour into a tall glass. Top with a drizzle of peanut butter or sliced banana if desired.',
    ],
    tips: [
      'Freeze the banana overnight for an extra thick, milkshake-like texture.',
      'Use chocolate whey protein with peanut butter for a Reese\'s-style flavor.',
      'Swap almond milk for whole milk to cut calories while keeping it creamy.',
      'Add a handful of spinach for extra vitamins - you will not taste it.',
    ],
    description: 'This Peanut Butter Protein Smoothie is a gym favourite for good reason. It combines the rich, nutty flavour of real peanut butter with high-quality whey protein for a post-workout recovery drink that actually tastes like a dessert. With 35 grams of protein, healthy fats from peanut butter, and natural carbs from banana, this smoothie covers all your macros in one delicious glass. It takes just 5 minutes to prepare and is perfect for those days when you need a quick, filling meal after a heavy session.',
  },
  {
    id: 2,
    slug: 'high-protein-peanut-butter-pancakes',
    title: 'High-Protein Peanut Butter Pancakes',
    excerpt: 'Fluffy, golden pancakes loaded with protein and peanut butter. A perfect high-protein breakfast for gym-goers with 40g protein per serving.',
    category: 'Breakfast',
    prepTime: '15 min',
    servings: 2,
    calories: 480,
    protein: '40g',
    carbs: '45g',
    fat: '16g',
    difficulty: 'Easy',
    image: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?w=800&q=80',
    tags: ['pancakes', 'peanut butter', 'breakfast', 'high protein', 'meal prep'],
    ingredients: [
      '1 scoop vanilla whey protein',
      '1/2 cup oats (blended into flour)',
      '2 tablespoons peanut butter',
      '1 whole egg + 2 egg whites',
      '1/3 cup milk',
      '1/2 teaspoon baking powder',
      '1 teaspoon vanilla extract',
      'Pinch of cinnamon',
      'Cooking spray or coconut oil for the pan',
    ],
    instructions: [
      'Blend the oats in a blender until they become a fine flour.',
      'In a mixing bowl, combine the oat flour, whey protein, baking powder, and cinnamon.',
      'In a separate bowl, whisk together the egg, egg whites, milk, 1 tablespoon of peanut butter (melted), and vanilla extract.',
      'Pour the wet ingredients into the dry ingredients and stir until just combined. Do not overmix - small lumps are fine.',
      'Heat a non-stick pan over medium heat and lightly grease with cooking spray.',
      'Pour about 1/4 cup of batter per pancake. Cook until bubbles form on the surface (about 2 minutes), then flip and cook for another 1-2 minutes.',
      'Stack the pancakes and top with the remaining tablespoon of peanut butter, sliced banana, and a drizzle of honey.',
    ],
    tips: [
      'Make a batch on Sunday and refrigerate for quick weekday breakfasts.',
      'Add a mashed banana to the batter for extra sweetness without sugar.',
      'Use chocolate whey protein for a chocolate peanut butter version.',
      'These pancakes freeze well - reheat in the microwave for 30 seconds.',
    ],
    description: 'These High-Protein Peanut Butter Pancakes are the ultimate bodybuilder breakfast. Unlike regular pancakes loaded with refined flour and sugar, these are made with oat flour, whey protein, and real eggs for a macros-friendly meal that keeps you full for hours. The peanut butter adds rich flavour and healthy fats while the whey protein ensures you hit your protein targets from the very first meal of the day. At 40g protein and only 480 calories per serving, these pancakes prove that eating for performance does not mean sacrificing taste.',
  },
  {
    id: 3,
    slug: 'peanut-butter-banana-protein-shake',
    title: 'Peanut Butter Banana Protein Shake',
    excerpt: 'The classic PB and banana combo turned into a quick, thick protein shake. Simple ingredients, massive gains - 30g protein in under 3 minutes.',
    category: 'Shakes',
    prepTime: '3 min',
    servings: 1,
    calories: 380,
    protein: '30g',
    carbs: '38g',
    fat: '14g',
    difficulty: 'Easy',
    image: 'https://images.unsplash.com/photo-1622597467836-f3285f2131b8?w=800&q=80',
    tags: ['protein shake', 'peanut butter', 'banana', 'quick', 'post workout'],
    ingredients: [
      '1 scoop whey protein (vanilla or chocolate)',
      '1 tablespoon peanut butter',
      '1 ripe banana',
      '1 cup cold milk',
      'A handful of ice cubes',
    ],
    instructions: [
      'Add cold milk to the blender.',
      'Break the banana into pieces and add to the blender along with the peanut butter.',
      'Add your scoop of whey protein and ice cubes.',
      'Blend for 30-45 seconds until smooth.',
      'Pour and drink immediately for the best texture.',
    ],
    tips: [
      'The riper the banana, the sweeter the shake - no added sugar needed.',
      'Use frozen banana slices instead of ice for an even thicker consistency.',
      'This shake works as a meal replacement when you are short on time.',
      'Add a tablespoon of oats for extra slow-release energy.',
    ],
    description: 'The Peanut Butter Banana Protein Shake is the simplest and fastest protein shake you can make. With just 5 ingredients and 3 minutes, you get a thick, naturally sweet shake loaded with 30g of protein. The banana provides quick carbs for glycogen replenishment, peanut butter adds healthy fats and flavour, and whey protein delivers the amino acids your muscles need. This is the shake you make when time is short but your nutrition cannot be compromised.',
  },
  {
    id: 4,
    slug: 'overnight-oats-protein-bowl',
    title: 'Overnight Protein Oats with Peanut Butter',
    excerpt: 'Prep the night before, grab and go in the morning. Creamy overnight oats with whey protein, peanut butter, and chia seeds - 32g protein.',
    category: 'Breakfast',
    prepTime: '5 min + overnight',
    servings: 1,
    calories: 450,
    protein: '32g',
    carbs: '48g',
    fat: '15g',
    difficulty: 'Easy',
    image: 'https://images.unsplash.com/photo-1517673400267-0251440c45dc?w=800&q=80',
    tags: ['overnight oats', 'meal prep', 'breakfast', 'peanut butter', 'high protein'],
    ingredients: [
      '1/2 cup rolled oats',
      '1 scoop vanilla whey protein',
      '1 tablespoon peanut butter',
      '1 tablespoon chia seeds',
      '3/4 cup milk (dairy or almond)',
      '1/4 cup Greek yogurt',
      'Toppings: sliced banana, berries, granola, honey',
    ],
    instructions: [
      'In a jar or container, combine the rolled oats, whey protein, and chia seeds.',
      'Add the milk and Greek yogurt. Stir everything together until well combined.',
      'Drop in the peanut butter and swirl it through (do not fully mix for a marbled effect).',
      'Cover the jar and refrigerate overnight (at least 6 hours).',
      'In the morning, give it a stir. Add a splash of milk if it is too thick for your liking.',
      'Top with sliced banana, berries, a sprinkle of granola, and a drizzle of honey.',
    ],
    tips: [
      'Make 3-4 jars on Sunday night for the entire work week.',
      'Chia seeds are key - they absorb liquid and create a pudding-like texture.',
      'Chocolate whey protein turns this into a chocolate peanut butter overnight oats.',
      'Overnight oats last 3-4 days in the refrigerator, so batch prep is easy.',
    ],
    description: 'Overnight Protein Oats are the ultimate meal prep breakfast for busy athletes. You spend 5 minutes the night before, and in the morning you have a ready-to-eat, protein-packed meal waiting in your fridge. The combination of oats, whey protein, chia seeds, and peanut butter creates a thick, creamy texture with 32g of protein and slow-release carbs that keep you energized all morning. This is how smart athletes start their day - prepared, fuelled, and never skipping breakfast.',
  },
  {
    id: 5,
    slug: 'chocolate-peanut-butter-protein-balls',
    title: 'Chocolate Peanut Butter Protein Balls',
    excerpt: 'No-bake, gym bag-friendly protein snacks. 10g protein per ball with chocolate whey and peanut butter. Ready in 15 minutes.',
    category: 'Snacks',
    prepTime: '15 min',
    servings: 10,
    calories: 120,
    protein: '10g',
    carbs: '12g',
    fat: '6g',
    difficulty: 'Easy',
    image: 'https://images.unsplash.com/photo-1604329760661-e71dc83f8f26?w=800&q=80',
    tags: ['protein balls', 'snack', 'no bake', 'peanut butter', 'chocolate', 'meal prep'],
    ingredients: [
      '2 scoops chocolate whey protein',
      '1/2 cup natural peanut butter',
      '1/2 cup rolled oats',
      '2 tablespoons honey',
      '2 tablespoons dark chocolate chips',
      '1 tablespoon cocoa powder',
      '2-3 tablespoons milk (to bind)',
    ],
    instructions: [
      'In a large bowl, combine the whey protein, oats, and cocoa powder.',
      'Add the peanut butter and honey. Mix with a spoon or your hands until it starts coming together.',
      'Add milk one tablespoon at a time until the mixture is sticky enough to roll into balls. Do not add too much - it should be thick.',
      'Fold in the chocolate chips.',
      'Scoop about 1 tablespoon of mixture and roll into a ball between your palms. Repeat to make 10 balls.',
      'Place on a parchment-lined tray and refrigerate for at least 30 minutes to firm up.',
      'Store in an airtight container in the fridge for up to one week.',
    ],
    tips: [
      'Roll them in crushed peanuts or desiccated coconut for extra texture.',
      'If the mixture is too dry, add more peanut butter. If too wet, add more oats.',
      'These are perfect for carrying in your gym bag as a pre or post-workout snack.',
      'Swap peanut butter for almond butter for a different flavour profile.',
    ],
    description: 'These Chocolate Peanut Butter Protein Balls are the perfect gym bag snack. No baking, no cooking, no hassle - just mix, roll, and refrigerate. Each ball packs 10g of protein from chocolate whey and peanut butter, making them an ideal pre-workout energy boost or post-workout quick snack. They taste like a chocolate peanut butter truffle but are actually fuelling your gains. Make a batch every Sunday and you have healthy, high-protein snacks ready for the entire week.',
  },
];
